export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    tableList: [
      {
        tableIdx: 1,
        tableGroupIdx: 1,
        name: "001",
        code: "mt01",
        row: 1,
        col: 1,
      },
      {
        tableIdx: 2,
        tableGroupIdx: 1,
        name: "002",
        code: "mt02",
        row: 1,
        col: 2,
      },
      {
        tableIdx: 3,
        tableGroupIdx: 1,
        name: "003",
        code: "mt02",
        row: 1,
        col: 3,
      },
      {
        tableIdx: 4,
        tableGroupIdx: 1,
        name: "004",
        code: "mt01",
        row: 1,
        col: 4,
      },
      {
        tableIdx: 5,
        tableGroupIdx: 1,
        name: "005",
        code: "mt02",
        row: 1,
        col: 5,
      },
      {
        tableIdx: 6,
        tableGroupIdx: 2,
        name: "001-2",
        code: "mt01",
        row: 2,
        col: 1,
      },
      {
        tableIdx: 7,
        tableGroupIdx: 2,
        name: "002",
        code: "mt02",
        row: 1,
        col: 2,
      },
      {
        tableIdx: 8,
        tableGroupIdx: 2,
        name: "003",
        code: "mt02",
        row: 1,
        col: 4,
      },
      {
        tableIdx: 9,
        tableGroupIdx: 2,
        name: "004",
        code: "mt01",
        row: 3,
        col: 1,
      },
      {
        tableIdx: 10,
        tableGroupIdx: 2,
        name: "005",
        code: "mt02",
        row: 2,
        col: 5,
      },
      {
        tableIdx: 11,
        tableGroupIdx: 1,
        name: "",
        code: "mt07",
        row: 3,
        col: 3,
      },
      {
        tableIdx: 12,
        tableGroupIdx: 1,
        name: "",
        code: "mt05",
        row: 3,
        col: 4,
      },
      {
        tableIdx: 13,
        tableGroupIdx: 1,
        name: "",
        code: "mt08",
        row: 3,
        col: 5,
      },
      {
        tableIdx: 14,
        tableGroupIdx: 2,
        name: "",
        code: "mt05",
        row: 3,
        col: 4,
      },
      {
        tableIdx: 15,
        tableGroupIdx: 2,
        name: "",
        code: "mt08",
        row: 3,
        col: 5,
      },
    ],
  },
};
